import { useQuery } from "@tanstack/react-query";
import { ArticlesServiceImpl } from "../../domain/services/articlesService";

const ArticlesService = new ArticlesServiceImpl();

export const useGetArticle = (slug: string) => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["article", slug],
    queryFn: () => ArticlesService.getArticle(slug),
    enabled: !!slug, // Only run the query if we have a slug
  });

  return { data, error, isLoading };
};
